export default {
  accessRight: "AccessRight",
  permission: "Permission",
};
